import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";
import useStores from "@hooks/useStores";
import { useLocation } from "react-router";

import Link from "@material-ui/core/Link";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";
import { animateScroll } from "react-scroll";

const ContentTOC = () => {
	const classes = useStyles("Content");
	const { contentStore: store } = useStores();
	const [scrollPosition, setScrollPosition] = useState(0);
	const [targetHashTag, setTargetHashTag] = useState();
	const location = useLocation();

	const handleScroll = () => {
		const position = window.pageYOffset;
		setScrollPosition(position);
	};

	const options = {
		renderNode: {
			[BLOCKS.OL_LIST]: (_, children) => {
				return <ol className={classes.longTOC}>{children}</ol>;
			},
			[BLOCKS.UL_LIST]: (_, children) => {
				return <ol className={classes.longTOC}>{children}</ol>;
			},
			[BLOCKS.PARAGRAPH]: (_, children) => {
				return children;
			},
			[BLOCKS.LIST_ITEM]: (node, children) => {
				const hashTag = store.findHashTagFromNode(node);
				return (
					<li className={targetHashTag === hashTag ? "active" : ""}>
						{children}
					</li>
				);
			},
		},
	};

	useEffect(() => {
		for (let i = store.refs.length - 1; i >= 0; i--) {
			const elem = store.refs[i].current;
			const { top } = elem.getBoundingClientRect();
			if (top <= 160) {
				setTargetHashTag(`#${elem.id}`);
				break;
			}
		}
	}, [scrollPosition]);

	useEffect(() => {
		window.addEventListener("scroll", handleScroll, { passive: true });
		setTargetHashTag(`#${store.refs[0]?.current?.id}`);
		if (location.hash) {
			const id = location.hash.slice(1);
			const offset = document.getElementById(id).getBoundingClientRect().top;
			animateScroll.scrollTo(offset - 159);
			setTargetHashTag(`#${id}`);
		}
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);

	if (!store.hasTableOfContents) return "";

	return (
		<nav>
			{documentToReactComponents(
				store.content.rightColumn.tableOfContents?.json,
				options
			)}
		</nav>
	);
};

ContentTOC.propTypes = {};
export default ContentTOC;
